/**
 * 接口域名的管理
 */


//演示环境 
const base = {
  sq: '/api',//请求代理需要用到
  bd: '/prod-api',
  // bd: 'http://localhost:9090',
  client: 'https://charge.576dl.com',
  // client: 'http://356357.xyz:7779',
  //慧知公众号
  appid: 'wx63910f1479c2cd32'
}





export default base;


